<central-login-header [platform]="currentPlatform"></central-login-header>
<div class="content">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="send()" >
        <h3 class="form-title">{{'central-login.forgot.password' | translate }}</h3>

        <div class="alert alert-info" *ngIf="resetMailSent">
            {{ 'central-login.forgot-password.mail.sent' | translate }}
            {{form.email.value}}
        </div>

        <div class="alert alert-danger p-2" *ngIf="requestFailure">
            {{ 'central-login.forgot-password.mail.error' | translate }}
        </div>

        <div class="form-group" *ngIf="!resetMailSent">
            <label class="form-control-label">{{'central-login.email' | translate }}
                <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.email.errors }" />
                <div *ngIf="submitted && form.email.errors" >
                    <div class="alert alert-danger mt-3 p-2 mb-0" *ngIf="form.email.errors.required">{{ 'central-login.email.required' | translate }}</div>
                    <div class="alert alert-danger mt-3 p-2 mb-0" *ngIf="form.email.errors.email">{{ 'central-login.email.not.valid' | translate }}</div>
                </div>
            </label>
        </div>

        <div class="row mt-3" *ngIf="!resetMailSent">
            <div class="col-md-12">
                <button type="submit" class="btn psd-variant w-100" [disabled]="submitting" >{{'central-login.send' | translate }}</button>
            </div>
        </div>
    </form>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform" ></central-login-background-slider>
